import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 * Ermöglicht das Anzeigen von Buttons aus Child-Komponenten im Header des Base-Settings-Dialogs.
 */
export class HeaderActionsService {
  readonly tpl$ = new BehaviorSubject<TemplateRef<unknown> | null>(null);
}
